/**
 * BATANOVA sepet: sözleşme onayı ve tahmini teslim tarihi.
 *
 * Horizon sepet çekmecesini her güncellemede morph ile yeniden çizer ve çekmece içindeki
 * <script>'ler çalışmaz. Bu yüzden bu dosya çekmecenin DIŞINDA (layout'ta) yüklenir;
 * olay yakalamayı document üzerinden yapar ve DOM değiştikçe durumu yeniden uygular.
 */
(function () {
  if (window.btSepetKuruldu) return;
  window.btSepetKuruldu = true;

  var ANAHTAR = 'bt_sozlesme_onay';
  var ODEME = '.cart__checkout-button, #checkout, button[name="checkout"]';

  function onayli() {
    try {
      return sessionStorage.getItem(ANAHTAR) === '1';
    } catch (e) {
      return !!window.btSozlesmeOnay;
    }
  }

  function onayYaz(deger) {
    window.btSozlesmeOnay = deger;
    try {
      sessionStorage.setItem(ANAHTAR, deger ? '1' : '0');
    } catch (e) {}
  }

  function senkron() {
    var onay = onayli();
    var kutular = document.querySelectorAll('[data-bt-sozlesme]');
    kutular.forEach(function (k) {
      if (k.checked !== onay) k.checked = onay;
    });
    // Onay kutusu olmayan sayfalarda (ör. ödeme dışı) butonlara dokunma
    if (!kutular.length) return;
    document.querySelectorAll(ODEME).forEach(function (b) {
      b.setAttribute('aria-disabled', String(!onay));
      b.classList.toggle('bt-odeme-kilitli', !onay);
      if (!onay) b.setAttribute('aria-describedby', 'bt-sozlesme-uyari');
      else b.removeAttribute('aria-describedby');
    });
    document.querySelectorAll('[data-bt-sozlesme-uyari]').forEach(function (u) {
      u.classList.toggle('is-gizli', onay);
    });
    tarihleriYaz();
  }

  function uyar() {
    document.querySelectorAll('[data-bt-sozlesme-uyari]').forEach(function (u) {
      u.classList.remove('is-gizli', 'is-titre');
      void u.offsetWidth;
      u.classList.add('is-titre');
    });
    var kutu = document.querySelector('[data-bt-sozlesme]');
    if (kutu) kutu.focus({ preventScroll: false });
  }

  // Onay kutusu değişince
  document.addEventListener('change', function (e) {
    if (!e.target.matches || !e.target.matches('[data-bt-sozlesme]')) return;
    onayYaz(e.target.checked);
    senkron();
  });

  // Onay yoksa ödemeye geçişi engelle (tıklama ve form gönderimi)
  document.addEventListener(
    'click',
    function (e) {
      var b = e.target.closest && e.target.closest(ODEME);
      if (!b || onayli() || !document.querySelector('[data-bt-sozlesme]')) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      uyar();
    },
    true
  );

  document.addEventListener(
    'submit',
    function (e) {
      var gonderen = e.submitter;
      if (!gonderen || gonderen.name !== 'checkout') return;
      if (onayli() || !document.querySelector('[data-bt-sozlesme]')) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      uyar();
    },
    true
  );

  // "Alışverişe devam et": çekmecedeyken sayfayı yenilemeden çekmeceyi kapat, sepet olduğu gibi kalır
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('[data-bt-alisverise-devam]');
    if (!a) return;
    var cekmece = a.closest('#cart-drawer');
    if (!cekmece) return; // Sepet sayfasında normal bağlantı gibi davranır
    e.preventDefault();
    var kapat = cekmece.querySelector('.theme-drawer__close-button, [on\\:click="#cart-drawer/close"]');
    if (kapat) kapat.click();
    else if (typeof cekmece.close === 'function') cekmece.close();
    else {
      var d = cekmece.querySelector('dialog[open]');
      if (d) d.close();
    }
  });

  // Tahmini teslim tarihi (Türkiye saati, iş günü)
  function tarihleriYaz() {
    document.querySelectorAll('[data-bt-sepet-teslim]').forEach(function (kap) {
      var hedef = kap.querySelector('[data-bt-sepet-tarih]');
      if (!hedef || hedef.dataset.yazildi) return;
      var hazirlik = Number(kap.dataset.hazirlik) || 2;
      var min = Number(kap.dataset.min) || 2;
      var max = Number(kap.dataset.max) || 4;
      var p = new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/Istanbul', year: 'numeric', month: '2-digit', day: '2-digit' }).formatToParts(new Date());
      var al = function (t) {
        return Number(p.find(function (x) { return x.type === t; }).value);
      };
      var bugun = new Date(al('year'), al('month') - 1, al('day'));
      var ekle = function (d, n) {
        var s = new Date(d);
        var k = 0;
        while (k < n) {
          s.setDate(s.getDate() + 1);
          if (s.getDay() !== 0 && s.getDay() !== 6) k++;
        }
        return s;
      };
      var hazir = ekle(bugun, hazirlik);
      var ilk = ekle(hazir, min);
      var son = ekle(hazir, max);
      var gunAy = new Intl.DateTimeFormat('tr-TR', { day: 'numeric', month: 'long' });
      var gun = new Intl.DateTimeFormat('tr-TR', { day: 'numeric' });
      var aralik = (ilk.getMonth() === son.getMonth() ? gun.format(ilk) : gunAy.format(ilk)) + '–' + gunAy.format(son);
      hedef.textContent = (hedef.dataset.onEk || 'Tahmini teslimat: ') + aralik;
      hedef.dataset.yazildi = '1';
    });
  }

  // Morph sonrası durumu yeniden uygula
  var bekliyor = false;
  new MutationObserver(function () {
    if (bekliyor) return;
    bekliyor = true;
    requestAnimationFrame(function () {
      bekliyor = false;
      senkron();
    });
  }).observe(document.documentElement, { childList: true, subtree: true });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', senkron);
  else senkron();
})();
